/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

import { GitMerge } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { SourceControlProvider } from '../../types';

export function SourceControlSettings() {
  const { sourceControlProvider, updateSourceControlProvider } = useApp();

  return (
    <div style={{ 
      marginBottom: '32px',
      padding: '20px',
      background: '#f9f9f9',
      borderRadius: '8px',
      border: '1px solid #ddd'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
        <GitMerge size={20} style={{ marginRight: '8px', color: '#0066cc' }} />
        <h3 style={{ margin: 0 }}>Source Control Provider</h3>
      </div>

      <div className="form-group">
        <label htmlFor="source-control-provider">Provider</label>
        <select
          id="source-control-provider"
          value={sourceControlProvider}
          onChange={(e) => updateSourceControlProvider(e.target.value as SourceControlProvider)}
          style={{
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            fontSize: '14px'
          }}
        >
          <option value="github">GitHub</option>
          <option value="gitlab">GitLab</option>
        </select>
        <small style={{ color: '#666', fontSize: '12px', display: 'block', marginTop: '8px' }}>
          Select which source control provider to use. Velocity integrates with either GitHub or GitLab, but not both simultaneously.
        </small>
      </div>
    </div>
  );
}
